export default __webpack_public_path__ + "static/media/checkmark_light.19ebe57e.svg";